import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';

import MemoTextField from './MemoTextField';
import MemoTextFieldSSN from './MemoTextFieldSSN';
import styles from './styles';

// @ts-expect-error FIXME TS2345
const useStyles = makeStyles()(styles);

interface ISSNFieldProps {
  isUpdating?: boolean;
}

export default function SSNField({ isUpdating }: ISSNFieldProps) {
  const { classes } = useStyles();
  const [showSSN, setShowSSN] = useState(false);

  const renderEndAdornmentSSN = () => (
    <InputAdornment position='end'>
      <IconButton
        size='small'
        onClick={() => setShowSSN((prevValue) => !prevValue)}
        id='credit-score-ssn-visibility-btn'
        aria-label='toggle SSN visibility'
        edge='end'
      >
        {showSSN ? <VisibilityOffIcon /> : <VisibilityOutlinedIcon />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <>
      <Grid item xs={12} mb={1} display='flex' alignItems='center'>
        <Typography variant='paragraphRegular'>Social Security Number</Typography>
        <Typography variant='paragraphRegular' fontSize={12} ml={1} color='text.tertiary'>
          (Safe and secure)
        </Typography>
      </Grid>
      <Grid container>
        <Grid item xs={6}>
          {isUpdating ? (
            <MemoTextFieldSSN
              label=''
              id='ssn'
              fieldName='ssn'
              type={showSSN ? 'text' : 'password'}
              variant='outlined'
              inputProps={{
                className: classes.ssnField,
              }}
              endAdornment={renderEndAdornmentSSN()}
            />
          ) : (
            <MemoTextField
              label=''
              fieldName='ssn'
              id='ssn'
              type={showSSN ? 'text' : 'password'}
              variant='outlined'
              placeholder='xxx-xx-xxxx'
              inputProps={{
                className: classes.ssnField,
                autoComplete: 'off',
              }}
              maxLength={11}
              endAdornment={renderEndAdornmentSSN()}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}
